import { RefObject } from 'react';

export type IframeMessagingContext = {
  iframeWindow: Window;
  targetOrigin: string;
};

export const getIframeMessagingContext = (iframeReference: RefObject<HTMLIFrameElement | null>) => {
  const iframeElement = iframeReference.current;
  if (!iframeElement?.contentWindow || !iframeElement.src) return;

  try {
    const targetOrigin = new URL(iframeElement.src).origin;
    return { iframeWindow: iframeElement.contentWindow, targetOrigin } satisfies IframeMessagingContext;
  } catch {
    return;
  }
};
